<template>
    <div class="product-questions flex-column">
        <div class="product-reviews-header">
            <p class="mb-3">Если у Вас возникли какие-либо сомнения или вопросы, наши специалисты будут рады Вам помочь.</p>
            <span class="btn btn-outline" @click.prevent="onClickAskButton" >Задать вопрос</span>
        </div>

        <div v-for="question in displayQuestions" class="testimonial-item product-question-item">
            <div class="testimonial-item-header">
                <div class="testimonial-item-header-icon" style="background: #03dbe8;">{{ question.author.charAt(0).toUpperCase() }}</div>
                <div class="testimonial-item-header-block">
                    <span class="name" itemprop="author">
                        {{ question.author }}
                        <span itemprop="datePublished" class="date ml-2">{{ question.posted_at }}</span>
                    </span>
<!--                    <span>-->
<!--                        <span v-if="question.city" class="city">{{ question.city }}</span>-->
<!--                    </span>-->
                </div>
            </div>
            <div class="testimonial-item-content mb-2">
                <div class="testimonial-item-content-text">
                    {{ question.question }}
                </div>
            </div>
            <div v-if="question.answer" class="testimonial-item-content testimonial-item-answer">
                <div class="answerer-title">КС-немецкая обувь</div>
                <span class="testimonial-item-content-text">{{ question.answer }}</span>
<!--                <div class="testimonial-item-content-text">
                    <span class="text-weight-regular">Ответ администратора: </span>
                    {{ question.answer }}
                </div>-->
            </div>
        </div>

        <a v-if="!displayAll && (questions.length > 5)" href="#" class="link mt-3" @click.prevent="displayAll = true">Показать все</a>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import Pagination from "../Pagination";

    export default {
        name: 'ProductQuestions',
        props: {
            id: {
                type: Number,
                required: true,
            }
        },
        components: {
            Pagination,
        },
        data: function () {
            return {
                page: 1,
                perPage: 10,
                displayAll: false,
            }
        },
        watch: {
            page (newValue, oldValue) {
                let elements = document.getElementsByClassName('product-question-item');

                if (elements.length) {
                    elements[0].scrollIntoView({
                        behavior: 'smooth',
                    });
                }
            }
        },
        mounted: function () {
            if (window.location.hash.substr(1) === 'askQuestion' && this.logged) {
                this.$root.toggle('product-info-questions');

                this.openFeedbackModal('question');
            }
        },
        methods: {
            ...mapMutations('auth', {
                showAuthModal: 'showModal',
                stayOnPageAfterAuth: 'stayOnPageAfterAuth'
            }),

            ...mapMutations('product', [
                'openFeedbackModal',
            ]),

            onClickAskButton () {
                if (!this.logged) {
                    this.stayOnPageAfterAuth('askQuestion');

                    this.showAuthModal();
                } else {
                    this.openFeedbackModal('question');
                }
            },

            setPage (page) {
                this.page = page;
            }
        },
        computed: {
            ...mapState('auth', [
                'logged',
            ]),
            ...mapState('product', [
                'questions',
            ]),
            count () {
                return this.questions.length;
            },
            hasQuestions () {
                return this.count !== 0;
            },
            questionsPage () {
                return this.questions.slice(
                    this.perPage * (this.page - 1),
                    this.perPage * this.page - 1
                );
            },
            totalPages () {
                return Math.ceil(this.questions.length / this.perPage);
            },
            displayQuestions () {
                return this.displayAll
                    ? this.questions
                    : this.questions.slice(0, 5);
            }
        }
    }
</script>
